import { Tournee } from "./Tournee";
import { SiteCabinetVeterinaire } from "./SiteCabinetVeterinaire";

export class TourneeEtablissement {
    tournee!: Tournee;
    tourneeId!: number;
    siteCabinetVeterinairetId!: number;
    siteCabinetVeterinaire: SiteCabinetVeterinaire = new SiteCabinetVeterinaire();
}